package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings13 {
  internal val verse_widget_interval_title: StringResource by lazy {
      init_verse_widget_interval_title() }

  internal val verse_widget_mikud_empty: StringResource by lazy { init_verse_widget_mikud_empty() }

  internal val verse_widget_nikud: StringResource by lazy { init_verse_widget_nikud() }

  internal val verse_widget_order_random: StringResource by lazy { init_verse_widget_order_random()
      }

  internal val verse_widget_order_sequential: StringResource by lazy {
      init_verse_widget_order_sequential() }

  internal val verse_widget_order_title: StringResource by lazy { init_verse_widget_order_title() }

  internal val verse_widget_preview: StringResource by lazy { init_verse_widget_preview() }

  internal val verse_widget_prompt: StringResource by lazy { init_verse_widget_prompt() }

  internal val verse_widget_sheet_cta: StringResource by lazy { init_verse_widget_sheet_cta() }

  internal val verse_widget_sheet_footer: StringResource by lazy { init_verse_widget_sheet_footer()
      }

  internal val verse_widget_sheet_intro: StringResource by lazy { init_verse_widget_sheet_intro() }

  internal val verse_widget_sheet_point_rhythm_body: StringResource by lazy {
      init_verse_widget_sheet_point_rhythm_body() }

  internal val verse_widget_sheet_point_rhythm_lead: StringResource by lazy {
      init_verse_widget_sheet_point_rhythm_lead() }

  internal val verse_widget_sheet_point_source_body: StringResource by lazy {
      init_verse_widget_sheet_point_source_body() }

  internal val verse_widget_sheet_point_source_lead: StringResource by lazy {
      init_verse_widget_sheet_point_source_lead() }

  internal val verse_widget_sheet_point_tap_body: StringResource by lazy {
      init_verse_widget_sheet_point_tap_body() }

  internal val verse_widget_sheet_point_tap_lead: StringResource by lazy {
      init_verse_widget_sheet_point_tap_lead() }

  internal val verse_widget_sheet_tag: StringResource by lazy { init_verse_widget_sheet_tag() }

  internal val verse_widget_sheet_title: StringResource by lazy { init_verse_widget_sheet_title() }

  internal val verse_widget_source_all: StringResource by lazy { init_verse_widget_source_all() }

  internal val verse_widget_source_book: StringResource by lazy { init_verse_widget_source_book() }

  internal val verse_widget_source_mikud: StringResource by lazy { init_verse_widget_source_mikud()
      }

  internal val verse_widget_source_parasha: StringResource by lazy {
      init_verse_widget_source_parasha() }

  internal val verse_widget_source_title: StringResource by lazy { init_verse_widget_source_title()
      }

  internal val verse_widget_tap_hint: StringResource by lazy { init_verse_widget_tap_hint() }

  internal val verse_widget_teamim: StringResource by lazy { init_verse_widget_teamim() }

  internal val verses_completion: StringResource by lazy { init_verses_completion() }

  internal val verses_copied_to_clipboard: StringResource by lazy {
      init_verses_copied_to_clipboard() }

  internal val version: StringResource by lazy { init_version() }

  internal val version_format: StringResource by lazy { init_version_format() }

  internal val version_format_one_argument: StringResource by lazy {
      init_version_format_one_argument() }

  internal val very_nice: StringResource by lazy { init_very_nice() }

  internal val vibrations: StringResource by lazy { init_vibrations() }

  internal val watch_ad: StringResource by lazy { init_watch_ad() }

  internal val welcome_female: StringResource by lazy { init_welcome_female() }

  internal val welcome_male: StringResource by lazy { init_welcome_male() }

  internal val what_to_copy_as_extra: StringResource by lazy { init_what_to_copy_as_extra() }

  internal val whats_new: StringResource by lazy { init_whats_new() }

  internal val where_to_search: StringResource by lazy { init_where_to_search() }

  internal val winners_list: StringResource by lazy { init_winners_list() }

  internal val with_nikud_and_teamim: StringResource by lazy { init_with_nikud_and_teamim() }

  internal val yechezkel: StringResource by lazy { init_yechezkel() }

  internal val yeshaaya: StringResource by lazy { init_yeshaaya() }

  internal val yirmeyah: StringResource by lazy { init_yirmeyah() }

  internal val your_grade: StringResource by lazy { init_your_grade() }

  internal val youth_bible_contest: StringResource by lazy { init_youth_bible_contest() }

  internal fun values(): List<StringResource> = listOf(verse_widget_interval_title,
      verse_widget_mikud_empty, verse_widget_nikud, verse_widget_order_random,
      verse_widget_order_sequential, verse_widget_order_title, verse_widget_preview,
      verse_widget_prompt, verse_widget_sheet_cta, verse_widget_sheet_footer,
      verse_widget_sheet_intro, verse_widget_sheet_point_rhythm_body,
      verse_widget_sheet_point_rhythm_lead, verse_widget_sheet_point_source_body,
      verse_widget_sheet_point_source_lead, verse_widget_sheet_point_tap_body,
      verse_widget_sheet_point_tap_lead, verse_widget_sheet_tag, verse_widget_sheet_title,
      verse_widget_source_all, verse_widget_source_book, verse_widget_source_mikud,
      verse_widget_source_parasha, verse_widget_source_title, verse_widget_tap_hint,
      verse_widget_teamim, verses_completion, verses_copied_to_clipboard, version, version_format,
      version_format_one_argument, very_nice, vibrations, watch_ad, welcome_female, welcome_male,
      what_to_copy_as_extra, whats_new, where_to_search, winners_list, with_nikud_and_teamim,
      yechezkel, yeshaaya, yirmeyah, your_grade, youth_bible_contest)
}

private fun init_verse_widget_interval_title(): StringResource = StringResource(key =
    "verse_widget_interval_title", loader = stringsLoader)

private fun init_verse_widget_mikud_empty(): StringResource = StringResource(key =
    "verse_widget_mikud_empty", loader = stringsLoader)

private fun init_verse_widget_nikud(): StringResource = StringResource(key = "verse_widget_nikud",
    loader = stringsLoader)

private fun init_verse_widget_order_random(): StringResource = StringResource(key =
    "verse_widget_order_random", loader = stringsLoader)

private fun init_verse_widget_order_sequential(): StringResource = StringResource(key =
    "verse_widget_order_sequential", loader = stringsLoader)

private fun init_verse_widget_order_title(): StringResource = StringResource(key =
    "verse_widget_order_title", loader = stringsLoader)

private fun init_verse_widget_preview(): StringResource = StringResource(key =
    "verse_widget_preview", loader = stringsLoader)

private fun init_verse_widget_prompt(): StringResource = StringResource(key = "verse_widget_prompt",
    loader = stringsLoader)

private fun init_verse_widget_sheet_cta(): StringResource = StringResource(key =
    "verse_widget_sheet_cta", loader = stringsLoader)

private fun init_verse_widget_sheet_footer(): StringResource = StringResource(key =
    "verse_widget_sheet_footer", loader = stringsLoader)

private fun init_verse_widget_sheet_intro(): StringResource = StringResource(key =
    "verse_widget_sheet_intro", loader = stringsLoader)

private fun init_verse_widget_sheet_point_rhythm_body(): StringResource = StringResource(key =
    "verse_widget_sheet_point_rhythm_body", loader = stringsLoader)

private fun init_verse_widget_sheet_point_rhythm_lead(): StringResource = StringResource(key =
    "verse_widget_sheet_point_rhythm_lead", loader = stringsLoader)

private fun init_verse_widget_sheet_point_source_body(): StringResource = StringResource(key =
    "verse_widget_sheet_point_source_body", loader = stringsLoader)

private fun init_verse_widget_sheet_point_source_lead(): StringResource = StringResource(key =
    "verse_widget_sheet_point_source_lead", loader = stringsLoader)

private fun init_verse_widget_sheet_point_tap_body(): StringResource = StringResource(key =
    "verse_widget_sheet_point_tap_body", loader = stringsLoader)

private fun init_verse_widget_sheet_point_tap_lead(): StringResource = StringResource(key =
    "verse_widget_sheet_point_tap_lead", loader = stringsLoader)

private fun init_verse_widget_sheet_tag(): StringResource = StringResource(key =
    "verse_widget_sheet_tag", loader = stringsLoader)

private fun init_verse_widget_sheet_title(): StringResource = StringResource(key =
    "verse_widget_sheet_title", loader = stringsLoader)

private fun init_verse_widget_source_all(): StringResource = StringResource(key =
    "verse_widget_source_all", loader = stringsLoader)

private fun init_verse_widget_source_book(): StringResource = StringResource(key =
    "verse_widget_source_book", loader = stringsLoader)

private fun init_verse_widget_source_mikud(): StringResource = StringResource(key =
    "verse_widget_source_mikud", loader = stringsLoader)

private fun init_verse_widget_source_parasha(): StringResource = StringResource(key =
    "verse_widget_source_parasha", loader = stringsLoader)

private fun init_verse_widget_source_title(): StringResource = StringResource(key =
    "verse_widget_source_title", loader = stringsLoader)

private fun init_verse_widget_tap_hint(): StringResource = StringResource(key =
    "verse_widget_tap_hint", loader = stringsLoader)

private fun init_verse_widget_teamim(): StringResource = StringResource(key = "verse_widget_teamim",
    loader = stringsLoader)

private fun init_verses_completion(): StringResource = StringResource(key = "verses_completion",
    loader = stringsLoader)

private fun init_verses_copied_to_clipboard(): StringResource = StringResource(key =
    "verses_copied_to_clipboard", loader = stringsLoader)

private fun init_version(): StringResource = StringResource(key = "version", loader = stringsLoader)

private fun init_version_format(): StringResource = StringResource(key = "version_format", loader =
    stringsLoader)

private fun init_version_format_one_argument(): StringResource = StringResource(key =
    "version_format_one_argument", loader = stringsLoader)

private fun init_very_nice(): StringResource = StringResource(key = "very_nice", loader =
    stringsLoader)

private fun init_vibrations(): StringResource = StringResource(key = "vibrations", loader =
    stringsLoader)

private fun init_watch_ad(): StringResource = StringResource(key = "watch_ad", loader =
    stringsLoader)

private fun init_welcome_female(): StringResource = StringResource(key = "welcome_female", loader =
    stringsLoader)

private fun init_welcome_male(): StringResource = StringResource(key = "welcome_male", loader =
    stringsLoader)

private fun init_what_to_copy_as_extra(): StringResource = StringResource(key =
    "what_to_copy_as_extra", loader = stringsLoader)

private fun init_whats_new(): StringResource = StringResource(key = "whats_new", loader =
    stringsLoader)

private fun init_where_to_search(): StringResource = StringResource(key = "where_to_search", loader
    = stringsLoader)

private fun init_winners_list(): StringResource = StringResource(key = "winners_list", loader =
    stringsLoader)

private fun init_with_nikud_and_teamim(): StringResource = StringResource(key =
    "with_nikud_and_teamim", loader = stringsLoader)

private fun init_yechezkel(): StringResource = StringResource(key = "yechezkel", loader =
    stringsLoader)

private fun init_yeshaaya(): StringResource = StringResource(key = "yeshaaya", loader =
    stringsLoader)

private fun init_yirmeyah(): StringResource = StringResource(key = "yirmeyah", loader =
    stringsLoader)

private fun init_your_grade(): StringResource = StringResource(key = "your_grade", loader =
    stringsLoader)

private fun init_youth_bible_contest(): StringResource = StringResource(key = "youth_bible_contest",
    loader = stringsLoader)

public actual val SharedRes.strings.verse_widget_interval_title: StringResource
  get() = CommonMainStrings13.verse_widget_interval_title

public actual val SharedRes.strings.verse_widget_mikud_empty: StringResource
  get() = CommonMainStrings13.verse_widget_mikud_empty

public actual val SharedRes.strings.verse_widget_nikud: StringResource
  get() = CommonMainStrings13.verse_widget_nikud

public actual val SharedRes.strings.verse_widget_order_random: StringResource
  get() = CommonMainStrings13.verse_widget_order_random

public actual val SharedRes.strings.verse_widget_order_sequential: StringResource
  get() = CommonMainStrings13.verse_widget_order_sequential

public actual val SharedRes.strings.verse_widget_order_title: StringResource
  get() = CommonMainStrings13.verse_widget_order_title

public actual val SharedRes.strings.verse_widget_preview: StringResource
  get() = CommonMainStrings13.verse_widget_preview

public actual val SharedRes.strings.verse_widget_prompt: StringResource
  get() = CommonMainStrings13.verse_widget_prompt

public actual val SharedRes.strings.verse_widget_sheet_cta: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_cta

public actual val SharedRes.strings.verse_widget_sheet_footer: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_footer

public actual val SharedRes.strings.verse_widget_sheet_intro: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_intro

public actual val SharedRes.strings.verse_widget_sheet_point_rhythm_body: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_point_rhythm_body

public actual val SharedRes.strings.verse_widget_sheet_point_rhythm_lead: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_point_rhythm_lead

public actual val SharedRes.strings.verse_widget_sheet_point_source_body: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_point_source_body

public actual val SharedRes.strings.verse_widget_sheet_point_source_lead: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_point_source_lead

public actual val SharedRes.strings.verse_widget_sheet_point_tap_body: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_point_tap_body

public actual val SharedRes.strings.verse_widget_sheet_point_tap_lead: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_point_tap_lead

public actual val SharedRes.strings.verse_widget_sheet_tag: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_tag

public actual val SharedRes.strings.verse_widget_sheet_title: StringResource
  get() = CommonMainStrings13.verse_widget_sheet_title

public actual val SharedRes.strings.verse_widget_source_all: StringResource
  get() = CommonMainStrings13.verse_widget_source_all

public actual val SharedRes.strings.verse_widget_source_book: StringResource
  get() = CommonMainStrings13.verse_widget_source_book

public actual val SharedRes.strings.verse_widget_source_mikud: StringResource
  get() = CommonMainStrings13.verse_widget_source_mikud

public actual val SharedRes.strings.verse_widget_source_parasha: StringResource
  get() = CommonMainStrings13.verse_widget_source_parasha

public actual val SharedRes.strings.verse_widget_source_title: StringResource
  get() = CommonMainStrings13.verse_widget_source_title

public actual val SharedRes.strings.verse_widget_tap_hint: StringResource
  get() = CommonMainStrings13.verse_widget_tap_hint

public actual val SharedRes.strings.verse_widget_teamim: StringResource
  get() = CommonMainStrings13.verse_widget_teamim

public actual val SharedRes.strings.verses_completion: StringResource
  get() = CommonMainStrings13.verses_completion

public actual val SharedRes.strings.verses_copied_to_clipboard: StringResource
  get() = CommonMainStrings13.verses_copied_to_clipboard

public actual val SharedRes.strings.version: StringResource
  get() = CommonMainStrings13.version

public actual val SharedRes.strings.version_format: StringResource
  get() = CommonMainStrings13.version_format

public actual val SharedRes.strings.version_format_one_argument: StringResource
  get() = CommonMainStrings13.version_format_one_argument

public actual val SharedRes.strings.very_nice: StringResource
  get() = CommonMainStrings13.very_nice

public actual val SharedRes.strings.vibrations: StringResource
  get() = CommonMainStrings13.vibrations

public actual val SharedRes.strings.watch_ad: StringResource
  get() = CommonMainStrings13.watch_ad

public actual val SharedRes.strings.welcome_female: StringResource
  get() = CommonMainStrings13.welcome_female

public actual val SharedRes.strings.welcome_male: StringResource
  get() = CommonMainStrings13.welcome_male

public actual val SharedRes.strings.what_to_copy_as_extra: StringResource
  get() = CommonMainStrings13.what_to_copy_as_extra

public actual val SharedRes.strings.whats_new: StringResource
  get() = CommonMainStrings13.whats_new

public actual val SharedRes.strings.where_to_search: StringResource
  get() = CommonMainStrings13.where_to_search

public actual val SharedRes.strings.winners_list: StringResource
  get() = CommonMainStrings13.winners_list

public actual val SharedRes.strings.with_nikud_and_teamim: StringResource
  get() = CommonMainStrings13.with_nikud_and_teamim

public actual val SharedRes.strings.yechezkel: StringResource
  get() = CommonMainStrings13.yechezkel

public actual val SharedRes.strings.yeshaaya: StringResource
  get() = CommonMainStrings13.yeshaaya

public actual val SharedRes.strings.yirmeyah: StringResource
  get() = CommonMainStrings13.yirmeyah

public actual val SharedRes.strings.your_grade: StringResource
  get() = CommonMainStrings13.your_grade

public actual val SharedRes.strings.youth_bible_contest: StringResource
  get() = CommonMainStrings13.youth_bible_contest
